import { LayerData, LAYER_TYPE } from './layer.data';
import { ShapeLayerData } from './shape-layer.data';

export class WingdingsShapeLayerData extends ShapeLayerData {

  private _char: string;
  private _font: string;

  /**
   * Contructor
   */
  constructor(char: string, font: string, color: string, x:number=0, y:number=0, width:number=NaN, height:number=NaN, rotation:number=0, alpha:number=1, locks:any=null, source:string="CreationLayer", special:string = null) {
    super(color, x, y, width, height, rotation, alpha, locks, source, special);
    
    this._char = char;
    this._font = font;
    this.type = LayerData.WINGDINGS_SHAPE;

    // console.log(this.font);
  }

  /**
	 * Char 
	 */
  public get char(): string {
    return this._char;
  }

  public set char(value: string) {
    this._char = value;
  }

  /**
   * Font 
   */
  public get font(): string {
    return this._font;
  }

  public set font(value: string) {
    this._font = value;
  }

  /**
   * Clone
   */
  public clone(keepData: boolean = false): LayerData {
    var layerData: WingdingsShapeLayerData = new WingdingsShapeLayerData(this._char, this._font, this._color);
    layerData.x = this.x;
    layerData.y = this.y;
    layerData.width = this.width;
    layerData.height = this.height;
    layerData.rotation = this.rotation;
    layerData.alpha = this.alpha;
    layerData.locks = keepData ? { position: this._locks.position, rotation: this._locks.rotation, size: this._locks.size, deletion: this._locks.deletion, depth: this._locks.depth, crop: this._locks.crop, tint: this._locks.tint } : null;
    layerData.source = this.source;
    layerData.special = this.special;
    layerData.index = keepData ? this._index : -1;

    return layerData;
  }

  /**
	 * Get data
	 */
  public getData(): any {
    var returnData: any = {
			type: LAYER_TYPE.SHAPE,
      design: this.source == LayerData.DESIGN ? 1 : 0,
      text: this._char,
      properties: {
        type: 4,
        x: this._x,
        y: this._y,
        width: this._width,
        height: this._height,
        rotation: this._rotation,
        color: this._color,
        font: this._font
      },
      locking: {
        position: this._locks.position,
        rotation: this._locks.rotation,
        size: this._locks.size,
        delete: this._locks.delete
      }
    };

    return returnData;
  }
  
}
